"use client";

import React from "react";
import Hero from "../components/home/hero";
import IntroStatement from "../components/home/intro-statement";
import HomeSkeletonLoader from "../components/ui/HomeSkeletonLoader";
import { useHomepageSectionContent } from "../hooks/useHomepageSectionContent";
import { getHomepageSectionDefinition } from "../content/homepageSections";
import type { AfricaEuropeBridgeSectionProps } from "../components/home/AfricaEuropeBridgeSection";
import SeoHead from "../seo/SeoHead";
import SchemaInjector from "../seo/components/SchemaInjector";
import { usePublicSeoPage } from "../seo/hooks/usePublicSeo";

const AwardsSection = React.lazy(() => import("../components/home/awards-section"));
const AfricaEuropeBridgeSection = React.lazy(() => import("../components/home/AfricaEuropeBridgeSection"));
const DestinationsSection = React.lazy(() => import("../components/home/destinations-section"));
const WhyPearlSection = React.lazy(() => import("../components/home/why-pearl-section"));
const PartnershipsAuthoritiesSection = React.lazy(() => import("../components/home/partnerships-authorities-section"));
const TestimonialsSection = React.lazy(() => import("../components/home/testimonials-section"));
const InquirySection = React.lazy(() => import("../components/home/inquiry-section"));

export default function HomePage() {
  const fallback = getHomepageSectionDefinition("africa-europe-bridge")?.defaultPayload as AfricaEuropeBridgeSectionProps;
  const { content, isInactive, isLoading } = useHomepageSectionContent<AfricaEuropeBridgeSectionProps>("africa-europe-bridge", fallback);
  const { data: seoResponse } = usePublicSeoPage("home");
  const seo = seoResponse?.seo;

  if (isLoading) {
    return (
      <main className="min-h-screen bg-[#fcfbf8] text-neutral-900">
        <HomeSkeletonLoader />
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-[#fcfbf8] text-neutral-900">
      <SeoHead
        title={seo?.title}
        description={seo?.description}
        image={seo?.image || seo?.ogImage}
        robots={seoResponse?.robots}
        hreflang={seoResponse?.hreflang}
      />
      <SchemaInjector schemas={seoResponse?.structuredData || []} />
      <Hero />
      {!isInactive ? (
        <React.Suspense fallback={null}>
          <AfricaEuropeBridgeSection {...content} />
        </React.Suspense>
      ) : null}
      {/* <CountriesWeOperateSection /> */}
      <IntroStatement />
      <React.Suspense fallback={null}>
        <AwardsSection />
        <DestinationsSection />
        <WhyPearlSection />
        <PartnershipsAuthoritiesSection />
        <TestimonialsSection />
        <InquirySection />
      </React.Suspense>
    </main>
  );
}
